import { Http } from "../Http";
export class NewpasswordresetApi {
 


    public static savenewpasswordreset(input: any) {
 
         
       // alert("saverole");
        var obj=JSON.stringify(input);
        var url="api/newpasswordreset";
        // if(input.jobId>0 ){
        //   //var url="api/updateSchedulerJobsRepository";
        // }
   
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
 
           // alert("Muru Return res "+JSON.stringify(res));
            return res;
          }).catch((e: any) => {
       
          //  alert("Muru Return Error "+e);
            return e.response;
          });
        //  alert("Muru Return resultMethod "+JSON.stringify(resultMethod)); 
        return resultMethod;
}

}